import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'
import DatePicker from 'components/DatePicker'

const WorkspaceFormReportedAt = ({ reportedAt, onChange }) => (
  <WorkspaceFormInput attribute='reportedAt'>
    <DatePicker
      className='workspace-form__input'
      selected={reportedAt}
      onChange={value => onChange({ reportedAt: value })}
      showTimeSelect
      timeIntervals={1}
      precision='minute'
    />
  </WorkspaceFormInput>
)

WorkspaceFormReportedAt.propTypes = {
  reportedAt: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  reportedAt: state.form.data.reportedAt
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormReportedAt)
